module.exports = __webpack_public_path__ + "static/index/img/baikal-400.ca03c27f.jpg";